<span
  [matTooltip]="displayableTooltip | translate"
  [matTooltipPosition]="tooltipPosition"
  [matTooltipClass]="tooltipClass"
  (click)="onClick($event)"
>
  <ng-template #buttonIconOrSpinner>
    @if (loading) {
      <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
    } @else if (icon) {
      <mat-icon [color]="iconColor">{{ icon }}</mat-icon>
    }
  </ng-template>

  @switch (buttonType) {
    @case ('raised') {
      <button
        mat-raised-button
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        (click)="onClick($event)"
      >
        <div class="icon-text-container">
          <ng-container *ngTemplateOutlet="buttonIconOrSpinner"></ng-container>
          {{ text }}
        </div>
      </button>
    }
    @case ('stroked') {
      <button
        mat-stroked-button
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        (click)="onClick($event)"
      >
        <div class="icon-text-container">
          <ng-container *ngTemplateOutlet="buttonIconOrSpinner"></ng-container>
          {{ text }}
        </div>
      </button>
    }
    @case ('secondary') {
      <button
        mat-stroked-button
        class="mat-secondary"
        [disabled]="isDisabled"
        [type]="actionType"
        (click)="onClick($event)"
      >
        <div class="icon-text-container">
          <ng-container *ngTemplateOutlet="buttonIconOrSpinner"></ng-container>
          {{ text }}
        </div>
      </button>
    }
    @case ('mat') {
      <button
        mat-button
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonIconOrSpinner"></ng-container>
        {{ text }}
      </button>
    }
    @case ('fab') {
      <button
        mat-fab
        [color]="color"
        [disabled]="isDisabled"
        [type]="actionType"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonIconOrSpinner"></ng-container>
        {{ text }}
      </button>
    }
    @case ('icon-button') {
      <button
        [color]="color"
        mat-icon-button
        matSuffix
        [disabled]="isDisabled"
        [type]="actionType"
        (click)="onClick($event)"
      >
        <ng-container *ngTemplateOutlet="buttonIconOrSpinner"></ng-container>
      </button>
    }
  }
</span>
